var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.CNF('copyright.visiable', true))?_c('div',[_vm._v(" "+_vm._s(_vm.CNF('copyright.text', ''))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }